// Experience data store
// Positions are stored with start/end dates for chronological sorting

export const experiences = [
  {
    id: "software-developer-intern-adya",
    company: "Adya.ai",
    role: "Software Developer Intern",
    duration: "June 2025 - Present",
    startDate: "2025-06-01",
    endDate: null,
    description: "Built AI-powered SaaS automation agents (Marketing, Voice-to-Voice, GTM) using FastAPI, Golang, and MCP, leading complete R&D, development, and testing while integrating Azure OpenAI, GCP, and third-party APIs (Apify, RapidAPI) for intelligent automation.",
    responsibilities: [
      "Led complete R&D, development, and testing of AI-powered SaaS automation agents",
      "Built Marketing, Voice-to-Voice, and GTM automation solutions using FastAPI and Golang",
      "Integrated Azure OpenAI, GCP, and third-party APIs (Apify, RapidAPI) for intelligent automation",
      "Collaborated with CTOs and PMs (INSEAD Alumni) in agile sprints",
      "Aligned AI-driven solutions with business objectives and delivered impactful client demos"
    ],
    technologies: ["FastAPI", "Golang", "MCP", "Azure OpenAI", "GCP", "Apify", "RapidAPI", "AI/ML"]
  },
  {
    id: "fullstack-developer-intern-unoiatech",
    company: "Unoiatech",
    role: "Full Stack Developer Intern",
    duration: "Jan 2025 - June 2025",
    startDate: "2025-01-01",
    endDate: "2025-06-30",
    description: "Began as a WordPress Developer and advanced to a Full Stack Developer, building scalable web solutions with RESTful APIs and delivering agile solutions aligned with business goals.",
    responsibilities: [
      "Advanced from WordPress Developer to Full Stack Developer role",
      "Built scalable web solutions with RESTful APIs",
      "Delivered agile solutions aligned with business goals",
      "Developed and maintained full-stack web applications",
      "Collaborated with cross-functional teams in agile environment"
    ],
    technologies: ["WordPress", "JavaScript", "React", "Node.js", "RESTful APIs", "Agile"]
  }
];
